import { authClient, API } from '../index'

export const getTickets = (params = {}) => {
  const qs = new URLSearchParams(params).toString()
  return authClient().get(`${API}/tickets${qs ? `?${qs}` : ''}`)
}

export const getTicketById = (id) => {
  return authClient().get(`${API}/tickets/${id}`)
}

export const updateTicket = (id, data) => {
  return authClient().put(`${API}/tickets/${id}`, data)
}

export const deleteTicket = (id) => {
  return authClient().delete(`${API}/tickets/${id}`)
}

export const countTickets = (params = {}) => {
  const qs = new URLSearchParams(params).toString()
  return authClient().get(`${API}/tickets/count${qs ? `?${qs}` : ''}`)
}

export const getTicketAvailability = (serviceName, date, site) => {
  const params = { serviceName, date }
  if (site) params.site = site
  const qs = new URLSearchParams(params).toString()
  return authClient().get(`${API}/tickets/availability?${qs}`)
}
